import * as React from 'react';
import { STATE } from 'app/constants';
import { myCaseDraftsTranslations } from 'app/area/my-case-drafts/constants';
import { containerFactory } from 'app/infrastructure/redux/index';
import { MainGridContainer } from 'ui/common/main-grid-container/main-grid-container';
import { scrollToTop } from 'app/infrastructure/platform/routing';
import { CaseDraftsTable } from 'app/area/my-case-drafts/case-drafts-table/case-drafts-table';
import styles from './my-case-drafts.scss';

export class MyCaseDraftsComponent extends React.Component<any, void> {
  public static statePath: string = STATE.myCaseDrafts;

  public componentDidMount() {
    scrollToTop();
  }

  public render() {
    const { translation } = this.props;
    return (<MainGridContainer className={styles.myCaseDraftsView}>
      <div className={styles.downloadItemsWrapper}>
        <div className="page-heading">
          <h1>{translation.my_case_drafts_header}</h1>
        </div>
        <div className="row">
          <CaseDraftsTable translation={translation} intl={this.props.intl} />
        </div>
      </div>
    </MainGridContainer>);
  }
}

const container = containerFactory(MyCaseDraftsComponent, {}, {}, myCaseDraftsTranslations);

export { container as MyCaseDrafts };
